import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './adminaddproduct.css'
 import { IoCloseSharp } from "react-icons/io5";
 import { BsMenuButtonWideFill } from "react-icons/bs";
import SideNavbaBarDashboard from '../SideNavaBarDashboard/SideNavbaBarDashboard';
import AdminHome from './AdminHome';
const AdminAddProduct = () => {
  const [categories, setCategories] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);

  const [formData, setFormData] = useState({
    productName: '',
    categories: [], // Changed to match schema
    description: '',
    originalPrice: '',
    salePrice: '',
    color: '',
    colorcode: '',
    deliveryDuration: [],
    marketerAddress: '',
    shoulderSize: [],
    madeInIndia: false,
    quantity: 1,
    serialNumber: '',

    material: '',
    brandName: '',
    sleeve: '',
    pattern: '',
    occasion: '',
    fabric: '',
    neckLine: '',
    discount: '',
    keywords: '',
    minOrderQuantity: 1,
    packingDetails: '',
    gst: '',
    hsn: '',
    images: []
  });

  const colors = [
    { name: "Red", code: "#FF0000" },
    { name: "Blue", code: "#0000FF" },
    { name: "Green", code: "#008000" },
    { name: "Yellow", code: "#FFFF00" },
    { name: "Orange", code: "#FFA500" },
    { name: "Purple", code: "#800080" },
    { name: "Pink", code: "#FFC0CB" },
    { name: "Black", code: "#000000" },
    { name: "White", code: "#FFFFFF" },
    { name: "Gray", code: "#808080" },
    { name: "Brown", code: "#A52A2A" },
    { name: "Cyan", code: "#00FFFF" },
    { name: "Magenta", code: "#FF00FF" },
    { name: "Lime", code: "#00FF00" },
    { name: "Maroon", code: "#800000" },
    { name: "Olive", code: "#808000" },
    { name: "Teal", code: "#008080" },
    { name: "Indigo", code: "#4B0082" },
    { name: "Violet", code: "#EE82EE" },
    { name: "Turquoise", code: "#40E0D0" },
    { name: "Gold", code: "#FFD700" },
    { name: "Silver", code: "#C0C0C0" },
    { name: "Peach", code: "#FFDAB9" },
    { name: "Mint Green", code: "#98FF98" },
    { name: "Navy Blue", code: "#000080" },
  ];


  const handleDropdownChange = (event) => {
    const selectedColor = event.target.value;
    setFormData((prev) => ({
      ...prev,
      color: selectedColor,
      colorcode: "", // Reset the color code when a new color is selected
    }));
  };

  const [styleData, setStyleData] = useState([]);
  const [categoryType, setCategoryType] = useState('');
  const [styleName, setStyleName] = useState('');

  const [uniqueCategoryData, setUniqueCategoryData] = useState({});
  const [selectedStyles, setSelectedStyles] = useState({});
  const [serialNumber, setSerialNumber] = useState(1); // To store and display serial number

  const handleCategoryChange = async (e) => {
    const selectedCategories = Array.from(e.target.selectedOptions, option => ({
      id: option.value,
      name: option.text,
      code: option.getAttribute('data-code')
    }));

    // Update the formData state with the selected category
    setFormData(prev => ({
      ...prev,
      categories: selectedCategories,

    }));

    // Assuming selectedCategories has at least one category selected (we're working with the first one here)
    const selectedCategoryId = selectedCategories[0]?.id;

    if (selectedCategoryId) {
      try {
        // Fetch the next serial number for the selected category
        const response = await axios.get(`/api/categories/${selectedCategoryId}/nextSerialNumber`);
        const nextSerialNumber = response.data.nextSerialNumber;

        setFormData(prev => ({
          ...prev,
          serialNumber: nextSerialNumber // Add the serialNumber to the formData
        }));

        setSerialNumber(nextSerialNumber); // Optionally, keep this in a separate state for immediate use in the UI
        // Set the fetched serial number
      } catch (error) {
        console.error('Error fetching next serial number:', error);
        setSerialNumber(1); // Default to 1 if an error occurs
      }
    }
  };






  useEffect(() => {
    const fetchStyleData = async () => {
      try {
        const response = await axios.get('/api/style-categories');
        const data = response.data;

        // Group styles by categoryType
        const groupedData = data.reduce((acc, item) => {
          if (!acc[item.categoryType]) {
            acc[item.categoryType] = [];
          }
          acc[item.categoryType].push(item.styleName);
          return acc;
        }, {});

        setStyleData(data);
        setUniqueCategoryData(groupedData);
      } catch (error) {
        console.error('Error fetching styles and categories:', error);
      }
    };
    fetchStyleData();
  }, []);


  const handleCategoryTypeChange = (e) => {
    setCategoryType(e.target.value);
    setStyleName(''); // Reset style name when category changes
  };

  const handleStyleNameChange = (e) => {
    setStyleName(e.target.value);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // Dropdown Options
  // const colors = ['Black', 'White', 'Blue', 'Red', 'Green', 'Navy', 'Gray', 'Pink'];



  const shoulderSizes = [32, 34, 36, 38, 40, 42, 44];

  const days = Array.from({ length: 6 }, (_, i) => {
    if (i === 0) return 1; // Start with 1
    return i * 2 + 2; // Start from 4 and add 2 for subsequent elements
  });

  console.log(days); // Output: [1, 4, 6, 8, 10, 12]


  const materials = ['Cotton', 'Polyester', 'Silk', 'Wool', 'Linen', 'Blend'];
  const sleeves = ['Full', 'Half', 'Three-Quarter', 'Sleeveless'];
  const patterns = ['Solid', 'Printed', 'Embroidered', 'Checked', 'Striped'];
  const occasions = ['Casual', 'Formal', 'Party', 'Wedding', 'Sports'];
  const neckLines = ['Round', 'V-Neck', 'Crew', 'Polo', 'Turtle'];


  const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  const [sizesWithQuantities, setSizesWithQuantities] = useState(
    sizes.map((size) => ({ size, quantity: 0 }))
  );


  ;




  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('/api/categories');
        console.log('Fetched categories:', response.data);
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);





  // const calculateSalePrice = (originalPrice, discount) => {
  //   const numOriginalPrice = parseFloat(originalPrice) || 0;
  //   const numDiscount = parseFloat(discount) || 0;



  //   return {
  //     originalPrice: numOriginalPrice,
  //     discount: numDiscount,
  //     salePrice: parseFloat(salePrice.toFixed(2))
  //   };
  // };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      setFormData(prev => {
        if (['deliveryDuration', 'shoulderSize', 'size'].includes(name)) {
          return {
            ...prev,
            [name]: checked
              ? [...(prev[name] || []), value]
              : (prev[name] || []).filter(item => item !== value)
          };
        }
        return { ...prev, [name]: checked };
      });
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };



  // const handlePriceChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === 'originalPrice' || name === 'discount') {
  //     const currentOriginalPrice = name === 'originalPrice' ? value : formData.originalPrice;
  //     const currentDiscount = name === 'discount' ? value : formData.discount;

  //     const pricing = calculateSalePrice(
  //       currentOriginalPrice,
  //       currentDiscount
  //     );

  //     setFormData(prev => ({
  //       ...prev,
  //       originalPrice: Math.round(pricing.originalPrice),
  //       salePrice: Math.round(pricing.salePrice),
  //       discount: Math.round(pricing.discount)
  //     }));
  //   } else {
  //     setFormData(prev => ({ ...prev, [name]: value }));
  //   }
  // }; 
  // const handleCategoryChange = (e) => {
  //   const selectedCategories = Array.from(e.target.selectedOptions, option => ({
  //     id: option.value,
  //     name: option.text
  //   }));

  //   setFormData(prev => ({
  //     ...prev,
  //     categories: selectedCategories
  //   }));
  // };
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(prevFiles => [...prevFiles, ...files]);

    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrls(prevUrls => [...prevUrls, reader.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemoveImage = (index) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    setPreviewUrls(prevUrls => prevUrls.filter((_, i) => i !== index));
  };


  const handleCheckboxChange = (categoryType, styleName) => {
    setSelectedStyles(prevSelectedStyles => {
      // Create a copy of the current styles for this category
      const currentCategoryStyles = prevSelectedStyles[categoryType] || [];

      // Check if the style is already selected
      const isStyleSelected = currentCategoryStyles.includes(styleName);

      // Update the styles array
      const updatedCategoryStyles = isStyleSelected
        ? currentCategoryStyles.filter(style => style !== styleName)
        : [...currentCategoryStyles, styleName];

      // Return updated selectedStyles object
      return {
        ...prevSelectedStyles,
        [categoryType]: updatedCategoryStyles
      };
    });
  };



  const handleQuantityChange = (size, value) => {
    // Convert input to number, default to 0 if invalid
    const numValue = parseInt(value) || 0;

    setSizesWithQuantities(prev =>
      prev.map(item =>
        item.size === size ? { ...item, quantity: numValue } : item
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();

      // Size mapping with number values
      const sizeMapping = {
        XS: 34,
        S: 36,
        M: 38,
        L: 40,
        XL: 42,
        '2XL': 44,
        '3XL': 46,
        '4XL': 48,
      };

      // Process sizes with proper type handling
      const sizesToSave = sizesWithQuantities
        .filter(item => Number(item.quantity) > 0)  // Ensure proper number comparison
        .map(item => ({
          size: sizeMapping[item.size],
          quantity: Number(item.quantity),  // Ensure quantity is converted to number
        }));

      // Process the form data with type safety
      const processedFormData = {
        ...formData,
        deliveryDuration: formData.deliveryDuration?.map(val => Number(val) || 0) || [],
        shoulderSize: formData.shoulderSize?.map(val => Number(val) || 0) || [],
        originalPrice: Number(formData.originalPrice) || 0,
        salePrice: Number(formData.salePrice) || 0,
        discount: Number(formData.discount) || 0,
        quantity: Number(formData.quantity) || 0,
        sizes: sizesToSave,
        sizesWithQuantities: sizesWithQuantities
          .filter((item) => Number(item.quantity) > 0)
          .map(item => ({
            ...item,
            quantity: Number(item.quantity)  // Ensure quantity is a number
          })),
      };

      // Append form data with type checking
      Object.entries(processedFormData).forEach(([key, value]) => {
        if (key !== 'images') {
          formDataToSend.append(
            key,
            typeof value === 'object' ? JSON.stringify(value) : String(value)
          );
        }
      });

      // Process styles with type safety
      const selectedStylesPayload = Object.entries(selectedStyles).map(([categoryType, styles]) => ({
        categoryType,
        selectedStyles: styles
      }));

      formDataToSend.append('selectedStyles', JSON.stringify(selectedStylesPayload));

      // Append images
      selectedFiles.forEach((file) => {
        formDataToSend.append('images', file);
      });

      // Send to server
      const response = await axios.post('/api/products', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Product created:', response.data);
      alert('Product created successfully!');

      // Reset form with proper initialization
      setFormData({
        productName: '',
        categories: [],
        description: '',
        originalPrice: '',
        salePrice: '',
        color: '',
        colorcode: '',
        deliveryDuration: [],
        marketerAddress: '',
        shoulderSize: [],
        madeInIndia: false,
        size: [],
        material: '',
        brandName: '',
        sleeve: '',
        pattern: '',
        occasion: '',
        fabric: '',
        neckLine: '',
        discount: '',
        keywords: '',
        packingDetails: '',
        gst: '',
        hsn: '',
        images: [],
        selectedStyles: '',
      });

      setSelectedStyles({});

      // Reset sizes with proper number initialization
      setSizesWithQuantities(
        sizes.map((size) => ({
          size,
          quantity: 0  // Ensure this is explicitly set to number 0
        }))
      );

      setSelectedFiles([]);
      setPreviewUrls([]);

    } catch (error) {
      console.error('Error creating product:', error);
      alert('Failed to create product');
    }
  };


  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '40px auto',
      padding: '30px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
    },
    formGroup: {
      marginBottom: '25px',
    },
    fieldset: {
      border: '1px solid #e1e1e1',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '25px',
      backgroundColor: '#fafafa',
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      color: '#374151',
      fontSize: '14px',
      fontWeight: '500',
    },
    input: {
      width: '100%',
      padding: '12px',
      border: '1px solid #e5e7eb',
      borderRadius: '6px',
      fontSize: '14px',
      transition: 'border-color 0.2s ease',
      backgroundColor: '#ffffff',
      '&:focus': {
        outline: 'none',
        borderColor: '#3b82f6',
        boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
      }
    },
    select: {
      width: '100%',
      padding: '12px',
      border: '1px solid #e5e7eb',
      borderRadius: '6px',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23666666'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 12px center',
      backgroundSize: '16px',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: '20px',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      overflow: 'hidden',
    },
    th: {
      padding: '12px 16px',
      textAlign: 'left',
      backgroundColor: '#f3f4f6',
      color: '#374151',
      fontWeight: '600',
      fontSize: '14px',
      borderBottom: '2px solid #e5e7eb',
    },
    td: {
      padding: '12px 16px',
      borderBottom: '1px solid #e5e7eb',
      fontSize: '14px',
    },
    checkboxContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      gap: '15px',
      padding: '15px',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      border: '1px solid #e5e7eb',
    },
    checkboxItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      backgroundColor: '#f9fafb',
      borderRadius: '6px',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f3f4f6',
      }
    },
    quantityInput: {
      width: '70px',
      padding: '6px 8px',
      border: '1px solid #e5e7eb',
      borderRadius: '4px',
      marginLeft: '10px',
      fontSize: '14px',
    },
    button: {
      width: '100%',
      padding: '14px',
      backgroundColor: 'green',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '16px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#4338ca',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 3px rgba(79, 70, 229, 0.1)',
      }
    },
    imagePreviewContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      gap: '15px',
      marginTop: '15px',
    },
    imagePreview: {
      position: 'relative',
      borderRadius: '8px',
      overflow: 'hidden',
      border: '1px solid #e5e7eb',
    },
    previewImage: {
      width: '100%',
      height: '150px',
      objectFit: 'cover',
    },
    removeButton: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      border: 'none',
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: '12px',
      cursor: 'pointer',
      color: '#ef4444',
      '&:hover': {
        backgroundColor: '#ffffff',
      }
    },
    flexContainer: {
      display: 'flex',
      gap: '20px',
      marginBottom: '25px',
    },
    flexItem: {
      flex: 1,
    },
    sizeBox: {
      padding: '8px 16px',
      border: '1px solid #e5e7eb',
      borderRadius: '4px',
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#f3f4f6',
      },
      '&.selected': {
        backgroundColor: '#4f46e5',
        color: '#ffffff',
        borderColor: '#4f46e5',
      }
    }
  };
  return (
    <>
      <section >
        <div className="tf-page-title style-2">
          <div className="container-full">
            <div className="heading text-center">
              Add Products</div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <AdminHome />
            <div style={styles.container} className='col-lg-9'>
              <form onSubmit={handleSubmit}>
                {/* Category and Style Selection */}
                <div style={styles.fieldset}>
                  <h4 className='heading'>Category and Style Selection</h4>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.th}>Category Type</th>
                        <th style={styles.th}>Style Names</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(uniqueCategoryData).map(([categoryType, styleNames], index) => (
                        <tr key={index}>
                          <td style={styles.td}>{categoryType}</td>
                          <td style={styles.td}>
                            {styleNames.map((styleName, idx) => (
                              <div key={idx} style={{ marginBottom: '8px' }}>
                                <label style={{ display: 'flex', alignItems: 'center' }}>
                                  <input
                                    type="checkbox"
                                    checked={selectedStyles[categoryType] && selectedStyles[categoryType].includes(styleName)}
                                    onChange={() => handleCheckboxChange(categoryType, styleName)}
                                    style={{ marginRight: '8px' }}
                                  />
                                  <span>{styleName}</span>
                                </label>
                              </div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div style={{ marginTop: '20px' }}>
                    <h4 style={{ marginBottom: '10px' }}>Selected Styles:</h4>
                    {Object.entries(selectedStyles).map(([categoryType, styles]) => (
                      <div key={categoryType} style={{ marginBottom: '8px' }}>
                        <strong>{categoryType}:</strong> {styles.join(', ')}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Basic Information */}
                <div style={styles.fieldset}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Category</label>
                    <select
                      style={styles.select}
                      name="categories"
                      value={formData.categories.map(cat => cat.id)}
                      onChange={handleCategoryChange}
                      required
                    >
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat._id} value={cat.categoryId} data-code={cat.categoryCode} style={{ fontFamily: "Raleway, serif" }}>
                          {cat.categoryName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={{ marginTop: '10px' }}>
                    <p>Next Serial Number: {serialNumber}</p>
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>Product Name *</label>
                    <input

                      type="text"
                      name="productName"
                      value={formData.productName}
                      onChange={handleChange}
                      required
                      style={{ fontFamily: "Raleway, serif" }}
                    />
                  </div>
                </div>

                {/* Color Information */}
                {/* <div style={styles.flexContainer}>
          <div style={styles.flexItem}>
            <label style={styles.label}>Color</label>
            <input
              style={styles.input}
              type="text"
              name="color"
              value={formData.color}
              onChange={handleChange}
              required
            />
          </div>
          <div style={styles.flexItem}>
            <label style={styles.label}>Color Code</label>
            <input
              style={styles.input}
              type="text"
              name="colorcode"
              value={formData.colorcode}
              onChange={handleChange}
              required
            />
          </div>
        </div> */}
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div>
                    <label style={{ fontWeight: "bold", marginRight: "8px" }}>Select Color:</label>
                    <select
                      style={{ padding: "8px", width: "200px" }}
                      value={formData.color}
                      onChange={handleDropdownChange}
                    >
                      <option value="" disabled>
                        -- Select a Color --
                      </option>
                      {colors.map((color) => (
                        <option key={color.name} value={color.name} style={{ fontFamily: "Raleway, serif" }}>
                          {color.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label style={{ fontWeight: "bold", marginRight: "8px" }}>Color Code:</label>
                    <input
                      style={{ padding: "8px", width: "200px", fontFamily: "Raleway, serif" }}
                      type="text"
                      name="colorcode"
                      value={formData.colorcode}
                      onChange={handleInputChange}
                      disabled={!formData.color}
                      placeholder={formData.color ? "Enter color code" : "Select a color first"}
                      required
                    />
                  </div>
                </div>

                {/* Image Upload */}
                <div style={styles.fieldset}>
                  <label style={styles.label}>Product Images</label>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFileSelect}
                    style={{ marginBottom: '15px' }}
                  />

                  {previewUrls.length > 0 && (
                    <div style={styles.imagePreviewContainer}>
                      {previewUrls.map((url, index) => (
                        <div key={index} style={styles.imagePreview}>
                          <img src={url} alt={`Preview ${index + 1}  style={styles.previewImage}`} />
                          <button
                            type="button"
                            onClick={() => handleRemoveImage(index)}
                            style={styles.removeButton}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Description */}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Description</label>
                  <textarea
                    style={{ ...styles.input, minHeight: '100px', fontFamily: "Raleway, serif" }}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Pricing */}
                <div style={styles.flexContainer}>
                  <div style={styles.flexItem}>
                    <label style={styles.label}>Original Price</label>
                    <input
                      style={{ fontFamily: "Raleway, serif" }}
                      type="number"
                      name="originalPrice"
                      value={formData.originalPrice}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div style={styles.flexItem}>
                    <label style={styles.label}>Discount (%)</label>
                    <input
                      style={{ fontFamily: "Raleway, serif" }}
                      type="number"
                      name="discount"
                      value={formData.discount}
                      onChange={handleInputChange}
                      min="0"
                      max="100"
                    />
                  </div>
                  <div style={styles.flexItem}>
                    <label style={styles.label}>Sale Price</label>
                    <input
                      style={{ ...styles.input, fontFamily: "Raleway, serif" }}
                      type="number"
                      name="salePrice"
                      value={formData.salePrice}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                {/* Delivery Duration */}
                <div style={styles.fieldset}>
                  <label style={styles.label}>Delivery Duration (Days)</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    {days.map((day) => (
                      <label key={day} style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="checkbox"
                          name="deliveryDuration"
                          value={day}
                          checked={formData.deliveryDuration.includes(day.toString())}
                          onChange={handleChange}
                          style={{ marginRight: '8px' }}
                        />
                        <span style={styles.sizeBox}>{day}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Shoulder Size */}
                <div style={styles.fieldset}>
                  <label style={styles.label}>Shoulder Size</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    {shoulderSizes.map((size) => (
                      <label key={size} style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="checkbox"
                          name="shoulderSize"
                          value={size}
                          checked={formData.shoulderSize.includes(size.toString())}
                          onChange={handleChange}
                          style={{ marginRight: '8px' }}
                        />
                        <span style={styles.sizeBox}>{size}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Material Selection */}
                <div style={styles.fieldset}>
                  <label style={styles.label}>Material</label>
                  <select
                    style={styles.select}
                    name="material"
                    value={formData.material}
                    onChange={handleChange}
                  >
                    <option value="" style={{ fontFamily: "Raleway, serif" }}>Select Material</option>
                    {materials.map(mat => (
                      <option key={mat} value={mat} style={{ fontFamily: "Raleway, serif" }}>{mat}</option>
                    ))}
                  </select>
                </div>

                {/* Clothing Sizes */}
                <div style={styles.fieldset}>
                  <label style={styles.label}>Clothing Sizes and Quantities</label>
                  <div style={styles.checkboxContainer}>
                    {sizesWithQuantities.map((item, index) => (
                      <div key={index} style={{ padding: '10px', border: '1px solid #e5e7eb', borderRadius: '6px' }}>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                          <input
                            type="checkbox"
                            value={item.size}
                            checked={item.quantity > 0}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              const updatedSizesWithQuantities = [...sizesWithQuantities];
                              updatedSizesWithQuantities[index].quantity = isChecked ? 1 : 0;
                              setSizesWithQuantities(updatedSizesWithQuantities);
                            }}
                            style={{ marginRight: '8px' }}
                          />
                          <span style={{ marginRight: '8px', fontFamily: "Raleway, serif" }}>{item.size}</span>
                          <input
                            type="number"
                            value={item.quantity}
                            min="0"
                            onChange={(e) => {
                              const updatedQuantity = parseInt(e.target.value, 10) || 0;
                              const updatedSizesWithQuantities = [...sizesWithQuantities];
                              updatedSizesWithQuantities[index].quantity = updatedQuantity;
                              setSizesWithQuantities(updatedSizesWithQuantities);
                            }}
                            style={{ ...styles.input, width: '70px', fontFamily: "Raleway, serif" }}
                            disabled={!item.quantity}
                          />
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Made in India Checkbox */}
                <div style={{ ...styles.formGroup, marginTop: '20px' }}>
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      name="madeInIndia"
                      checked={formData.madeInIndia}
                      onChange={handleChange}
                      style={{ marginRight: '8px' }}
                    />
                    <span>Made in India</span>
                  </label>
                </div>
                <div style={{ marginTop: '30px' }}>
                  <button
                    type="submit"
                    style={styles.button}
                  >
                    Create Product
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


        <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
          <div className="canvas-wrapper">
            <header className="canvas-header">
              <span className="title">SIDEBAR ACCOUNT</span>
              <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
              {/* <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span> */}
            </header>

            <div className="canvas-body sidebar-mobile-append"> </div>
          </div>
        </div>
      </section>

      <div className="btn-sidebar-account">
                            <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                                <BsMenuButtonWideFill />
                            </button>
                        </div>
            
                        <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                            <div className="canvas-wrapper">
                                <header className="canvas-header">
                                    <span className="title">SIDEBAR ACCOUNT</span>
                                    {/* <SideNavbaBarDashboard /> */}
                                    <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                                </header>
                                
                                <div className="canvas-body sidebar-mobile-append"> </div>
                            </div>
                        </div>
    </>
  );
};






export default AdminAddProduct;